import HikSetRecordingEnabledModal from './hik-set-recording-enabled-modal.vue'
export default HikSetRecordingEnabledModal
